import { Box, Flex, Text, useDateTimeFormat, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { Markdown } from 'components'

import { MessageGroupStack } from '../../../types'
import { DialogueAvatar } from './DialogueAvatar'
import { StackMessageDebug } from './StackMessageDebug'

type Props = {
  messages: MessageGroupStack['messages']
}

export const StackMessage: FC<Props> = props => {
  const { messages } = props

  const dateTimeFormat = useDateTimeFormat()

  const { authorName, authorRole, created } = messages[messages.length - 1]
  const isAgentMessage = authorRole === 'agent'

  if (messages.every(({ text }) => !text)) {
    return null
  }

  return (
    <VStack space="s-2" data-testid="dialogue-snapshot-stack-message">
      {messages.map(message => {
        if (!message.text) {
          return null
        }

        if (message.debug) {
          return <StackMessageDebug key={message.messageId} {...message} />
        }

        return (
          <Flex
            key={message.messageId}
            justifyContent={isAgentMessage ? 'flex-end' : undefined}
          >
            <Box maxWidth="calc(100% - 64px)" bg="background" borderRadius="24px">
              <Box
                width="100%"
                bg={isAgentMessage ? 'grey-tone-2' : 'grey-tone-10'}
                px="s-16"
                py="s-8"
                borderRadius="20px"
              >
                <Text variant="secondary">
                  <Markdown chatUiRenderMethod>{message.text}</Markdown>
                </Text>
              </Box>
            </Box>
          </Flex>
        )
      })}
      <DialogueAvatar
        isAgentMessage={isAgentMessage}
        authorName={authorName}
        dateTime={dateTimeFormat(new Date(created))}
      />
    </VStack>
  )
}
